export default __webpack_public_path__ + "static/media/HP9.ba022e6d.jpg";